export default __webpack_public_path__ + "static/media/chart-03.cdeeb900.svg";